import { z } from "zod";
/**
 * Özellik bayrakları (AGENTS.md §3.13): modüller kiracı ve istasyon bazında açılır/kapanır.
 * Çözümleme sırası: istasyon override → kiracı override → plan. Kapalı modülün API'si 403 FEATURE_DISABLED döner.
 */
export const FEATURES = {
    // İş birimleri
    FUEL: "Akaryakıt",
    LPG: "LPG / otogaz",
    MARKET: "Market",
    WASH: "Araç yıkama",
    EV: "Elektrikli araç şarjı",
    CAFE: "Kafe / restoran",
    RENTAL: "Kiralık alanlar",
    // Modüller
    ACCOUNTING: "Muhasebe",
    CURRENT_ACCOUNTS: "Cari hesaplar",
    CASH_BANK: "Kasa, banka ve POS",
    CHEQUES: "Çek ve senet",
    E_DOCUMENTS: "e-Fatura / e-Arşiv / e-İrsaliye",
    EXPENSES_BUDGET: "Gider, onay akışları ve bütçe",
    SHIFTS: "Vardiya ve kasa kapanışı",
    STATION_AGENT: "İstasyon ajanı ve cihaz entegrasyonu",
    LOCAL_POS: "Yerel kasa (POS)",
    FLEET_LOYALTY: "Filo / TTS ve sadakat",
    ALERTS: "Alarm ve bildirimler",
    REPORTS: "Raporlar ve gösterge panelleri",
    MOBILE_APP: "Mobil uygulama",
    ASSET_COMPLIANCE: "Varlık bakımı ve uyum takvimi",
    MULTI_COMPANY: "Birden çok şirket",
    API_ACCESS: "API erişimi",
};
export const FEATURE_KEYS = Object.keys(FEATURES);
export const featureKeySchema = z.enum(FEATURE_KEYS);
export const BUSINESS_UNIT_TYPES = ["FUEL", "LPG", "MARKET", "WASH", "EV", "CAFE", "RENTAL"];
export const businessUnitTypeSchema = z.enum(BUSINESS_UNIT_TYPES);
export const BUSINESS_UNIT_LABELS = {
    FUEL: "Akaryakıt",
    LPG: "LPG",
    MARKET: "Market",
    WASH: "Araç yıkama",
    EV: "Elektrikli araç şarjı",
    CAFE: "Kafe",
    RENTAL: "Kiralık alan",
};
//# sourceMappingURL=features.js.map